import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import questionsAdmin from "../../../../apis/admin/question";
import TextArea from "antd/lib/input/TextArea";
import { Link, useNavigate, useParams } from "react-router-dom";
import notificationHandler from "../../../atoms/Notification";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";

const EditQuestion = () => {
  const navigate = useNavigate();
  const { Title } = Typography;
  const [questions, setQuestions] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const [dataQuestions, setDataQuestions] = useState({
    questionOrder: 0,
    title: "",
    type: 0,
    content: "",
    status: 0,
    options: [
      {
        optionOrder: 0,
        value: "",
      },
    ],
  });

  const { id }: any = useParams();
  const [form] = Form.useForm();
  const [checkQuestion, setCheckQuestion] = useState(0);

  const [modal, contextHolder] = Modal.useModal();

  const confirm = (values: any) => {
    modal.confirm({
      title: "Bạn có chắc chắn muốn thay đổi dữ liệu?",
      icon: <ExclamationCircleOutlined />,
      okText: "Đồng ý ",
      cancelText: "Hủy",
      okType: "danger",
      onOk: () => onFinish(values),
    });
  };

  React.useEffect(() => {
    questionsAdmin
      .getOneQuestions(id)
      .then((res: any) => {
        const options = res.data.data.payload.options.map(
          (item: any, index: number) => {
            return item.value;
          }
        );
        if (
          res.data.data.payload.type !== null ||
          res.data.data.payload.type !== ""
        ) {
          setCheckQuestion(res.data.data.payload.type);
        }
        const datas = {
          questionOrder: res.data.data.payload.questionOrder,
          content: res.data.data.payload.content,
          status: res.data.data.payload.status,
          type: res.data.data.payload.type,
          options: options,
        };
        form.setFieldsValue(datas);
      })
      .catch((error) => {});
  }, []);

  const onFinish = (values: any) => {
    let options;
    if (values?.options) {
      options = values?.options?.map((item: any, index: number) => {
        let obj = {
          optionOrder: index,
          value: item,
        };
        return obj;
      });
    }
    const content = values.content;
    const data = {
      questionOrder: +values.questionOrder,
      title: "",
      type: values.type,
      content: content.toString(),
      status: +values.status,
      options: checkQuestion == 1 && options ? options : null,
    };
    questionsAdmin
      .updateQuestions(id, data)
      .then(() => {
        notificationHandler("success", "Sửa câu hỏi khảo sát thành công!");
        navigate("/admin/listQuestion");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  const onChange = (values: number) => {
    setCheckQuestion(values);
  };
  const validateNumber = (_: any, value: any) => {
    if (value < 1) {
      return Promise.reject(new Error("Vui lòng không nhập số âm!"));
    }
    return Promise.resolve();
  };

  const setTrimValue = React.useCallback(
    (index: number, value: string) => {
      form.getFieldValue("options")[index] = value.trim();
      form.setFieldValue("options", form.getFieldValue("options"));
    },
    [form.getFieldValue("options")]
  );

  return (
    <div className="p-[20px]">
      <Spin indicator={antIcon} spinning={loading} />
      <Title className="!text-[20px]">Sửa câu hỏi khảo sát</Title>
      <Form
        form={form}
        name="change menu"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        layout={"vertical"}
        style={{ maxWidth: 600 }}
        onFinish={confirm}
        autoComplete="off"
      >
        <Form.Item
          label="Vị trí câu hỏi"
          name={"questionOrder"}
          rules={[
            { required: true, message: "Vui lòng nhập thứ tự câu hỏi!" },
            { validator: validateNumber },
          ]}
        >
          <Input
            placeholder="Nhập vị trí câu hỏi"
            type="number"
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="Nội dung câu hỏi"
          name={"content"}
          rules={[
            { required: true, message: "Vui lòng nhập nội dung câu hỏi!" },
          ]}
        >
          <TextArea showCount rows={4} maxLength={200} />
        </Form.Item>
        <Form.Item
          label="Trạng thái"
          name={"status"}
          rules={[{ required: true, message: "Vui lòng chọn trạng thái!" }]}
        >
          <Select
            style={{ width: "100%" }}
            placeholder={"Chọn trạng thái"}
            options={[
              { value: 0, label: "Không hoạt động" },
              { value: 1, label: "Hoạt động" },
            ]}
          />
        </Form.Item>
        <Form.Item label="Loại câu hỏi" name={"type"}>
          <Radio.Group
            name="radiogroup"
            defaultValue={0}
            onChange={(e) => onChange(e.target.value)}
          >
            <Radio value={0}>Tự luận</Radio>
            <Radio value={1}>Trắc nghiệm</Radio>
          </Radio.Group>
        </Form.Item>
        <div className={checkQuestion === 0 ? "hidden" : ""}>
          <Form.List
            name="options"
            rules={[
              {
                validator: async (_, names) => {
                  if (checkQuestion === 1 && (!names || names.length < 1)) {
                    return Promise.reject(
                      new Error("Vui lòng thêm câu trả lời!")
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {checkQuestion === 1 &&
                  fields.map((field, index) => (
                    <Form.Item
                      label={
                        index === 0
                          ? "Câu trả lời số 1"
                          : "Câu trả lời số " + (index + 1)
                      }
                      required={false}
                      key={field.key}
                    >
                      <Form.Item
                        {...field}
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message: "Vui lòng nhập câu trả lời!",
                          },
                        ]}
                        noStyle
                        className="flex items-center"
                      >
                        <Input
                          placeholder="Nhập câu trả lời"
                          style={{ width: "90%" }}
                          showCount
                          maxLength={200}
                          onBlur={(e) =>
                            setTrimValue(field.key, e.target.value)
                          }
                        />
                      </Form.Item>
                      {fields.length > 0 ? (
                        <MinusCircleOutlined
                          className="dynamic-delete-button ml-2 bottom-[-5px] relative cursor-pointer text-primary text-[24px]"
                          onClick={() => remove(field.name)}
                        />
                      ) : null}
                    </Form.Item>
                  ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    style={{ width: "60%" }}
                    icon={<PlusOutlined />}
                  >
                    Thêm câu trả lời
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        </div>
        <Form.Item>
          <div className="flex">
            <Button
              htmlType="button"
              type="primary"
              className="mt-4 mr-4 border-[#808080] hover:border-[#808080] hover:text-[#808080] hover:bg-white bg-[#808080] text-white"
            >
              <Link to={"/admin/listQuestion"} className="flex items-center">
                <ArrowLeftOutlined className="mr-2" /> Quay lại
              </Link>
            </Button>
            <Button
              htmlType="submit"
              type="primary"
              className="mt-4 bg-[#1890ff] hover:bg-white hover:text-[#1890ff]"
              loading={loading}
            >
              <SaveOutlined /> Cập nhật
            </Button>
            <Button
              htmlType="reset"
              className="mt-4 text-[##ff4d4f] ml-4  bg-[#ff4d4f] text-white"
              danger
            >
              <ReloadOutlined /> Đặt lại
            </Button>
          </div>
        </Form.Item>
        {contextHolder}
      </Form>
    </div>
  );
};

export default EditQuestion;
